import Service from '@/pages/dashboard/components/PageContainer/Service';
import React from 'react';
import { useKpiEventDimensionTrendServiceOuter } from './_hooks/useKpiEventDimensionTrendServiceOuter';
import type { IKpiEventDimensionTrendServiceProps } from './_type';
import KpiEventDimensionTrendInner from './KpiEventDimensionTrendInner';

const KpiEventDimensionTrendService = (props: IKpiEventDimensionTrendServiceProps) => {
  const {
    hideBlock,
    className,
    style,
    serviceMountKey,
    wrappedApi,
    data,
    dataKey,
    trackData,
    beforeRequest,
    formatData,
    innerProps,
  } = useKpiEventDimensionTrendServiceOuter(props);

  if (hideBlock) {
    return null;
  }

  return (
    <div className={className} style={style}>
      <Service
        key={serviceMountKey}
        api={wrappedApi as string | ((data: unknown, outParame?: unknown) => void)}
        data={data}
        dataKey={dataKey as string}
        trackData={trackData as unknown as string[]}
        beforeRequest={beforeRequest}
        formatData={formatData as string | ((data: unknown, filterVal?: unknown) => unknown)}
      >
        <KpiEventDimensionTrendInner {...innerProps} />
      </Service>
    </div>
  );
};

export default KpiEventDimensionTrendService;
